import React, { Component, Fragment, createContext } from "react"
import WithBlock from "data/wrappers/WithBlock"
import RenderTree from "../../RenderTree"
import { blocks, text } from "features/editor/attributes/items/primitives"
import { TreeInstance } from "features/editor/tree/tree"
import { Container } from "ui"
import { BlockContextProvider, BlockContextConsumer, input } from "features/editor/ContextProviders"
import { DragDropContext } from "features/editor/dnd/Context"
import { BroadcastContext, Provider as BroadcastContextProvider } from "../../broadcast/Context"

/**
 * @augments {Component<BlockTypeProps<{text: string}>, any>}
 */
export default class CustomBlockType extends Component {
    state = { edits: { edit: null, callback: null } }

    render() {
        const Wrapper = this.props.Wrapper
        return (
            <Wrapper {...this.props}>
                {({ attrs, computedStyle, evaluateFormulas, updateAttributes, selected }) => (
                    <Container className="isNotEditing">
                        <WithBlock blockId={attrs.block_id}>
                            {({ block }) => {
                                return (
                                    <DragDropContext isActive={false}>
                                        {dragDropContext => (
                                            <BlockContextProvider
                                                dragDropContext={dragDropContext}
                                                data={{
                                                    ...this.props.context,
                                                    deviceType: null,
                                                    propertyStore: null,
                                                    editor: null,
                                                    actions: null,
                                                    direction: null,
                                                    dragDrop: null,
                                                    block: null,
                                                    record: null,
                                                    tree: null,
                                                    input: null,
                                                    actions: {
                                                        onHover: noOp,
                                                        selectBlock: noOp,
                                                        addBroadcast: noOp,
                                                        removeBroadcast: noOp,
                                                    },
                                                    editor: {
                                                        //  ...this.props.context.editor,
                                                        isEditing: false,
                                                    },
                                                }}
                                            >
                                                <input.Provider value={evaluateFormulas(attrs)}>
                                                    <BroadcastContextProvider value={{ items: {} }}>
                                                        <BroadcastContext
                                                            debugger={true}
                                                            debugMessage="CustomBlock"
                                                        >
                                                            {/* <ContextDebug /> */}

                                                            <RenderTree
                                                                instance={
                                                                    new TreeInstance(block.blocks)
                                                                }
                                                            />
                                                        </BroadcastContext>
                                                    </BroadcastContextProvider>
                                                </input.Provider>
                                            </BlockContextProvider>
                                        )}
                                    </DragDropContext>
                                )
                            }}
                        </WithBlock>
                    </Container>
                )}
            </Wrapper>
        )
    }
}

const ContextDebug = props => (
    <BlockContextConsumer>{context => JSON.stringify(context, null, 3)}</BlockContextConsumer>
)

CustomBlockType.attributes = [blocks({ field: "block_id", label: "Block" })]

CustomBlockType.renderAttributes = ({ attributes, renderAttribute, configuredAttributes }) => {
    // get blockID
    return (
        <Fragment>
            {attributes.map(renderAttribute)}
            <WithBlock blockId={configuredAttributes.block_id}>
                {({ block }) => {
                    let inputs = block.options.inputs || []
                    return inputs.map((option, i) =>
                        renderAttribute(text({ field: option.key, label: option.label }), i)
                    )
                }}
            </WithBlock>
        </Fragment>
    )
}

const noOp = () => {}



// WEBPACK FOOTER //
// ./src/features/editor/blockTypes/other/CustomBlock.js